/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const TwilioMessagingNew = defineMessages({
  titleOne: {
    id: 'twilioMessaging.TwilioMessagingNew.titleOne',
    defaultMessage: 'Your customers are texting'
  },
  titleTwo: {
    id: 'twilioMessaging.TwilioMessagingNew.titleTwo',
    defaultMessage: 'Your assistant can answer'
  },
  descriptionOne: {
    id: 'twilioMessaging.TwilioMessagingNew.descriptionOne',
    defaultMessage:
      'With Twilio, your assistant is ready to send and receive SMS and MMS text messages.'
  },
  descriptionTwo: {
    id: 'twilioMessaging.TwilioMessagingNew.descriptionTwo',
    defaultMessage:
      'This integration can even pair with <link>phone calls</link>, enabling your assistant to send and receive texts with a caller.'
  },
  simpleFormTitle: {
    id: 'twilioMessaging.TwilioMessagingNew.simpleFormTitle',
    defaultMessage: 'Get started with just a phone number'
  },
  phoneHelpText: {
    id: 'twilioMessaging.TwilioMessagingNew.phoneHelpText',
    defaultMessage: "Don't worry, you can change this later."
  },
  phoneHelpMore: {
    id: 'twilioMessaging.TwilioMessagingNew.phoneHelpMore',
    defaultMessage:
      'Cannot be the same as another Watson Assistant messaging integration.'
  },
  instructions: {
    id: 'twilioMessaging.TwilioMessagingNew.instructions',
    defaultMessage: "What you'll need"
  },
  instructionsDescription: {
    id: 'twilioMessaging.TwilioMessagingNew.instructionsDescription',
    defaultMessage:
      "This integration requires some setup. Select Create to get all the details, but here's what to expect:"
  },
  instructionsItemOne: {
    id: 'twilioMessaging.TwilioMessagingNew.instructionsItemOne',
    defaultMessage:
      'Get a Twilio phone number with SMS capabilities. (MMS optional)'
  },
  instructionsItemTwo: {
    id: 'twilioMessaging.TwilioMessagingNew.instructionsItemTwo',
    defaultMessage:
      'In Watson Assistant, a webhook identifier will be generated for you.'
  },
  instructionsItemThree: {
    id: 'twilioMessaging.TwilioMessagingNew.instructionsItemThree',
    defaultMessage:
      "In Twilio, you'll set your phone number's messaging to configure with webhooks and the generated identifier."
  },
  learnMore: {
    id: 'twilioMessaging.TwilioMessagingNew.learnMore',
    defaultMessage: '<link>Learn more about SMS with Twilio</link>'
  }
});

export const TwilioMessagingQuickSetup = defineMessages({
  title: {
    id: 'twilioMessaging.TwilioMessagingQuickSetup.title',
    defaultMessage: 'Set up Twilio Messaging'
  },
  accountSidLabel: {
    id: 'twilioMessaging.TwilioMessagingQuickSetup.accountSidLabel',
    defaultMessage: 'Account SID'
  },
  phoneNumber: {
    id: 'twilioMessaging.TwilioMessagingQuickSetup.phoneNumber',
    defaultMessage: 'Phone number'
  },
  authTokenLabel: {
    id: 'twilioMessaging.TwilioMessagingQuickSetup.authTokenLabel',
    defaultMessage: 'Auth token'
  },
  webhookUriLabel: {
    id: 'twilioMessaging.TwilioMessagingQuickSetup.webhookUriLabel',
    defaultMessage: 'Webhook URI'
  }
});

export const IntroStepMessages = defineMessages({
  title: {
    id: 'twilioMessaging.IntroStepMessages.title',
    defaultMessage: 'Set up Twilio Messaging'
  },
  instructions: {
    id: 'twilioMessaging.IntroStepMessages.instructions',
    defaultMessage: 'Steps to setting up Twilio Messaging'
  },
  instructionsItemOne: {
    id: 'twilioMessaging.IntroStepMessages.instructionsItemOne',
    defaultMessage:
      "Get a Twilio phone number with SMS capabilities (MMS optional). In Twilio, set your phone number's messaging to configure with webhooks, which should be its default."
  },
  instructionsItemTwo: {
    id: 'twilioMessaging.IntroStepMessages.instructionsItemTwo',
    defaultMessage: 'Enter your Twilio account SID and authentication token.'
  },
  instructionsItemThree: {
    id: 'twilioMessaging.IntroStepMessages.instructionsItemThree',
    defaultMessage:
      "Copy and paste this webhook identifier as the address for incoming messages. Make sure it's set to HTTP POST."
  }
});

export const PhoneNumberStepMessages = defineMessages({
  title: {
    id: 'twilioMessaging.PhoneNumberStepMessages.title',
    defaultMessage: 'Phone number'
  },
  description: {
    id: 'twilioMessaging.PhoneNumberStep.description',
    defaultMessage:
      'Add the phone number your provider uses for SMS integration below:'
  }
});
